import React from "react";
import "./styles.scss";
import { connect } from "react-redux";
import { ReactComponent as DragAndDropCover } from "../../public/drag_n_drop.svg";
import { draggableMediaTypes } from "../../api/media";
import { Redirect } from "react-router-dom";
import actions from "../../redux/actions";
import { withRouter } from "react-router-dom";

class DragAndDrop extends React.Component {
  state = { showDragAndDropZone: false, okDrop: false };
  componentDidMount() {
    document.addEventListener("dragenter", this.showDropZone);
  }
  componentWillUnmount() {
    document.removeEventListener("dragenter", this.showDropZone);
  }
  showDropZone = e => {
    if (!document.getElementsByClassName("modal show").length)
      this.setState({ showDragAndDropZone: true });
  };
  hideDropZone = e => this.setState({ showDragAndDropZone: false });
  allowDrag = e => {
    if (this.state.showDragAndDropZone) {
      e.preventDefault();
      e.dataTransfer.dropEffect = "copy";
      e.dataTransfer.effectAllowed = "copy";
    }
  };
  handleDrop = e => {
    if (this.state.showDragAndDropZone) {
      e.preventDefault();
      this.hideDropZone();
      this.props.dispatch(actions.setFile(e.dataTransfer.files[0]));
    }
  };
  render() {
    const { pathname } = this.props.location;
    if (
      pathname.includes("/upload/album") ||
      pathname.includes("/upload/done")
    ) {
      return null;
    }
    return this.state.showDragAndDropZone ? (
      <div
        id="drag-n-drop"
        style={{ display: this.state.showDragAndDropZone ? "flex" : "none" }}
        onDragOver={this.allowDrag}
        onDragEnter={this.allowDrag}
        onDragLeave={this.hideDropZone}
        onDrop={this.handleDrop}
      >
        <DragAndDropCover width={580} />
      </div>
    ) : this.props.file &&
      draggableMediaTypes.includes(this.props.file.type) ? (
      <Redirect to="/upload/single" />
    ) : null;
  }
}

function mapStateToProps(state) {
  const { file } = state;
  return { file };
}
export default connect(mapStateToProps)(withRouter(DragAndDrop));
